module.exports = __webpack_public_path__ + "static/media/cowbell-1.923c89fd.gif";